

import firebase from 'firebase/compat/app'

const firebaseConfig = {

    apiKey: "AIzaSyCgV_kr1zJ9WTPrQN6qBZMCNCl0yFSS7_s",

    authDomain: "gomoku-77118.firebaseapp.com",

    projectId: "gomoku-77118",

    storageBucket: "gomoku-77118.appspot.com",

    messagingSenderId: "1044424100807",

    appId: "1:1044424100807:web:b3ad5889afe884a39467e2",

    measurementId: "G-40VZ5WTK9L"

};


const app = firebase.initializeApp(firebaseConfig)

if (window.location.hostname === "localhost") {
    firebase.auth().useEmulator("http://localhost:9099")
}

export default app;